import Swal, { swal } from "sweetalert2/dist/sweetalert2.js";
const AlertError = (title = "ผิดพลาด", text, opts = {}) => {
    return Swal.fire({
        title: title,
        text: text,
        icon: "error",
        confirmButtonText: opts.confirmButtonText ?? "ตกลง",
        ...(opts.timer != null ? { timer: opts.timer } : {}),
    });
}


export default AlertError